import React from 'react'
import './../Form.css'

const ImageUpload = props => {
    const {id, label, defaultImage, setImage} = props;
    const [previewUrl, setPreviewUrl] = React.useState(defaultImage);
    function handleChange(event) {
        if(event.target.files[0]) {
            setImage(event.target.files[0]);
            setPreviewUrl(URL.createObjectURL(event.target.files[0]));
        }else if(!previewUrl){
            setPreviewUrl(defaultImage);
        }
    }

    return (
        <div className="form-element">
            <label>{label}</label>
            <label className="upload-pic-button">
                { previewUrl && <img src={previewUrl} alt="Upload+"/> }
                <i className="fa fa-camera"></i>
                <input style={{ display: 'none' }} id={id} type="file" accept="image/*" onChange={handleChange}/>
            </label>
        </div>
    )
}

export default ImageUpload
